import SimpleTeaser from './SimpleTeaser';

export default SimpleTeaser;
